import { makeAutoObservable } from 'mobx'
import { allThemeNames, ThemeNames, ThemeScheme } from '@/themes'
import { devLog } from '@methods/devLog'
import { RootStore } from './Root.store'

export class InterfaceStore {
  private rootStore: RootStore
  themeId: ThemeNames = 'signicatTheme' as ThemeNames
  themeScheme: ThemeScheme = 'light'
  themeInitialized: boolean = false
  sendBeforeunloadEvent: boolean = true

  constructor(rootStore: RootStore) {
    makeAutoObservable(this)
    this.rootStore = rootStore
  }

  setTheme(scheme: ThemeScheme, theme: unknown): void {
    if (this.themeInitialized) return

    devLog('setTheme: ', scheme, theme, 'scheme skipped until dark themes are introduced')

    // To be implemented when first dark theme is ready
    // if (themes[scheme].hasOwnProperty(theme)) {
    //   this.themeScheme = scheme
    //   // @ts-expect-error #TODO fix this typing
    //   this.theme = themes[scheme][theme]
    // } else {
    //   this.themeScheme = 'light'
    //   this.theme = themes['light'][theme] || themes['light']['signicatTheme']
    // }

    if (allThemeNames.includes(theme as ThemeNames)) {
      const typedTheme = theme as ThemeNames

      this.themeId = typedTheme
      this.themeScheme = 'light'
    }

    devLog('App: Theme initialized', new Date().toISOString())

    this.themeInitialized = true
  }

  setSendBeforeunloadEvent(sendEvent: boolean): void {
    this.sendBeforeunloadEvent = sendEvent
  }
}
